import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { styled } from '@mui/material/styles';

export const TextareaAutosize = styled(BaseTextareaAutosize)(
  () => `
    box-sizing: border-box;
    padding: 16px;
    border-radius: 6px;
    background: var(--dk-bg, #fff);
    border: 1px solid var(--dk-line, #E7E9EC);
    color: var(--dk-text, #000);
    font-size: 14px;
    line-height: 20px;
    font-family: var(--font-apple-gothic);

    &:hover {
      border-color: var(--dk-text, #000);
    }
    
    &.error {
      border-color: var(--dk-danger, #F55060);
    }

    &:focus {
      border-color: var(--dk-text, #000);
    }
    
    ::placeholder {
      color: var(--dk-text-dim, #B7BBC2);
      font-size: 14px;
      line-height: 20px;
      font-family: var(--font-apple-gothic);
    }

    &:focus-visible {
      outline: 0;
    }
  `,
);
